
<template>
  <base-container>
    <el-table
      border
      stripe
      :data="schedules"
      size="mini"
      highlight-current-row
    >
      <el-table-column
        align="center"
        header-align="center"
        prop="startPoint"
        label="开始时间"
        width="120px"
      >
      </el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        prop="endPoint"
        label="结束时间"
        width="120px"
      >
      </el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        prop="totalCount"
        label="总号源数"
        width="120px"
      >
      </el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        prop="resCount"
        label="剩余号源数"
      >
      </el-table-column>
    </el-table>
  </base-container>
</template>

<script>
export default {
  props: {
    schedules: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
    };
  },
  computed: {
   
  },
};
</script>

<style>
</style>